import Vue from 'vue'
import Router from 'vue-router'

import Full from '@/containers/Full'
import Login from '@/components/Login'
import Users from '@/components/Users'
import SystemUsers from '@/components/SystemUsers'
import Configuration from '@/components/Configuration'
import TestsEditor from '@/components/TestsEditor'
import AfterAuth from '@/components/AfterAuth'

import DocList from '@/components/exchange/DocList'
import CommissionRef from '@/components/exchange/CommissionRef.vue'
import UserDossier from '@/components/exchange/UserDossier.vue'
import Funding from '@/components/exchange/Funding.vue'
import NetworkWallets from '@/components/exchange/NetworkWallets.vue'
import OrdersQueue from '@/components/exchange/OrdersQueue.vue'
import TwoFactor from '@/components/TwoFactor.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/afterauth',
      name: 'AfterAuth',
      component: AfterAuth,
    },
    {
      // Mandatory 2FA enrollment redirect target (reachable only via
      // requires_2fa_setup from /syslogin). Stand-alone, no chrome.
      path: '/2fa-setup',
      name: 'TwoFactorSetup',
      component: TwoFactor,
      props: { mode: 'mandatory' },
    },
    {
      path: '/',
      // Persist the session across tab close: if the user still has a
      // JWT in localStorage, go through /afterauth (which hydrates the
      // Vuex store and routes them to their landing page). Without
      // this the root URL always forced /login, throwing a logged-in
      // user back to the login form whenever they reopened the tab.
      redirect: () => (window.localStorage.getItem('authUser') ? '/afterauth' : '/login'),
      component: Full,
      children: [
        {
          path: '/users',
          name: 'Users',
          component: Users,
          meta: { requiresAuth: true },
        },
        {
          path: '/system-users',
          name: 'SystemUsers',
          component: SystemUsers,
          meta: { requiresAuth: true },
        },
        {
          path: '/configuration',
          name: 'Configuration',
          component: Configuration,
          meta: { requiresAuth: true },
        },
        {
          path: '/tests',
          name: 'TestsEditor',
          component: TestsEditor,
          meta: { requiresAuth: true },
        },
        {
          path: '/doclist',
          name: 'DocList',
          component: DocList,
          meta: { requiresAuth: true },
        },
        {
          // Volume-tiered комиссионная таблица (ref_commission).
          // На неё опирается computeQuote() в новом order flow —
          // ставка комиссии зависит от размера ордера в USD.
          path: '/commissionref',
          name: 'CommissionRef',
          component: CommissionRef,
          meta: { requiresAuth: true },
        },
        {
          // Финансы клиентов — очередь депозитов + ручное начисление.
          // Защищено серверной ролью ADMIN; на фронте дополнительная
          // проверка не нужна — endpoint вернёт 403 неадмину.
          path: '/admin/funding',
          name: 'Funding',
          component: Funding,
          meta: { requiresAuth: true },
        },
        {
          // Депозит-адреса компании по сетям (один адрес на цепь).
          path: '/admin/network-wallets',
          name: 'NetworkWallets',
          component: NetworkWallets,
          meta: { requiresAuth: true },
        },
        {
          // Очередь торговых ордеров — PENDING / AWAITING_RECONFIRM /
          // EXECUTING. Зеркало /admin/funding по структуре.
          path: '/admin/orders',
          name: 'OrdersQueue',
          component: OrdersQueue,
          meta: { requiresAuth: true },
        },
        {
          // Standalone full-page dossier — replaces the previous
          // in-place UserDetail render. Side panel in Users.vue still
          // imports UserDetail directly for the inline read-only view.
          path: '/userdetail/:userId',
          name: 'UserDetail',
          component: UserDossier,
          props: true,
          meta: { requiresAuth: true },
        },
        {
          path: '/security',
          name: 'Security',
          component: TwoFactor,
          props: { mode: 'settings' },
          meta: { requiresAuth: true },
        },
      ],
    },
  ],
})
